import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb);
};

const onTokenRefreshed = () => {
  refreshSubscribers.forEach((cb) => cb());
  refreshSubscribers = [];
};

const apiClient = axios.create({ 
  baseURL: API,
  timeout: 60000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// No request interceptor needed — cookies are sent automatically

apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;
    const isRegistrationPage = window.location.pathname === "/inscription" || window.location.pathname === "/" || window.location.pathname === "/login";
    
    // If 401 and not already retrying and not the refresh endpoint itself
    if (err.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes('/auth/refresh')) {
      
      if (isRefreshing) {
        // Wait for token refresh to complete
        return new Promise((resolve) => {
          subscribeTokenRefresh(() => {
            resolve(apiClient(originalRequest));
          });
        });
      }
      
      originalRequest._retry = true;
      isRefreshing = true;
      
      try {
        // Try to refresh the token (cookie-based)
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        onTokenRefreshed();
        isRefreshing = false;
        return apiClient(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        isRefreshing = false;
        refreshSubscribers = [];
        
        // Only redirect if NOT on registration page
        if (!isRegistrationPage) {
          window.location.href = "/login";
        }
      }
    }
    
    return Promise.reject(err);
  }
);

export default apiClient;
export { API, BACKEND_URL };
